import api from '../api';

import { ParamsDataGetRelationship } from 'utils/typeServices';

export const GetRelationship = async ({ token }: { token: string }) => {
    try {
        const { data } = await api.get<{ Data: Array<ParamsDataGetRelationship> }>('/v1/Cliente/GetRelationship', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
